<template>
  <header class="sitenav">
    <div class="">
      <div class="row">
        <div class="col-12">
          <b-navbar toggleable="lg" class="d-flex align-items-start" type="light" :class="{sticky: isFixed}">
            <b-navbar-brand to="/" class="">
              <img
                class="img-fluid"
                src="../assets/imgs/copaprosa2025/logo-copa-2025.png"
                alt="Copa Prosa"
              />
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" class="pt-5 pt-lg-3" is-nav>
              <b-navbar-nav class="ml-auto">
                <b-nav-item class="fG btnrojo text-center pt-2 bold cerrarsesion lighter" to="/">
                  Inicio
                </b-nav-item>
                <b-nav-item class="fG btnrojo text-center pt-2 bold cerrarsesion lighter" to="/agenda">
                  Agenda
                </b-nav-item>
                <b-nav-item class="fG btnrojo text-center pt-2 bold cerrarsesion lighter" to="torneo">
                  Torneo
                </b-nav-item>
                <b-nav-item class="fG btnrojo text-center pt-2 bold cerrarsesion lighter" to="/faqs">
                  FAQs
                </b-nav-item>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import * as fb from "../firebase";

export default {
  data() {
    return {
      uid: null,
      stickyTop: 10,
      isFixed: false
    };
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 10) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
    logout() {
      this.$store.dispatch("logout");
    },
  },
};
</script>
